<template>
  <span>
    <v-tooltip v-if="isIconButton" top>
      <template v-slot:activator="{ on }">
        <v-icon @click="csvDownload" v-on="on" class="download-button">
          save_alt
        </v-icon>
      </template>
      <span>レポートをダウンロードする</span>
    </v-tooltip>
    <AppButtonOk v-else @click="csvDownload">CSVダウンロード</AppButtonOk>
  </span>
</template>

<script>
import { IntervalReportRepository } from '@/models/Report/IntervalReport'
import { CsvUtil } from '@/middlewares/CsvUtil'

export default {
  name: 'IntervalReportListButtonDownload',
  props: {
    intervalReport: {
      type: Object,
      default: () => {},
    },
    isIconButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    encode() {
      return this.intervalReport.notification.encode
    },
    name() {
      return this.intervalReport.name
    },
  },
  methods: {
    async csvDownload() {
      try {
        const reportCsv = await IntervalReportRepository.getCsvReport(
          this.intervalReport,
        )
        CsvUtil.download(reportCsv, this.name, this.encode)
      } catch (e) {
        console.error(e)
        throw new Error('ダウンロードに失敗しました。')
      }
    },
  },
}
</script>

<style>
.download-button {
  cursor: pointer;
}
</style>
